/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyEuro = createReactComponent("outline", "currency-euro", "IconCurrencyEuro", [["path", { "d": "M17.2 7a6 7 0 1 0 0 10", "key": "svg-0" }], ["path", { "d": "M13 10h-8m0 4h8", "key": "svg-1" }]]);

export { IconCurrencyEuro as default };
//# sourceMappingURL=IconCurrencyEuro.mjs.map
